<template>
  <div class="menuContainer">
    <p class="title">客户服务</p>
    <el-menu
      :default-active="activeProduct"
      class="el-menu-demo"
      mode="vertical"
      router
      text-color="#333"
    >
      <el-menu-item index="/customerService/exchangeRate"
        >外汇牌价</el-menu-item
      >
    </el-menu>
  </div>
</template>

<script>
export default {
  computed: {
    activeProduct() {
      return this.$route.path
    },
  },
}
</script>

<style lang="scss" scoped></style>
